import { render, staticRenderFns } from "./IconCardFail.vue?vue&type=template&id=02c9d803&scoped=true&"
var script = {}
import style0 from "./IconCardFail.vue?vue&type=style&index=0&id=02c9d803&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c9d803",
  null
  
)

export default component.exports